<div class="schedule-navbar">
    <div class="position-relative">
        <button (click)="prev()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-left"></mat-icon>
        </button>

        @if (firstPendingDate) {
            <div class="pending-dot"></div>
        }
    </div>
    <div class="content" (click)="today()">
        <p class="large">{{ date | date: 'd MMM yyyy' }}</p>

        <p class="small">{{ date | date: 'EEEE' }}</p>
    </div>
    <div>
        <button [disabled]="date >= maxDate" (click)="next()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-right"></mat-icon>
        </button>
    </div>
</div>
<div class="plannings">
    @if (user) {
        <div class="user">
            {{ user.name }}
        </div>
    }

    @if (overlapping) {
        <div class="user">Je hebt overlappende uren ingevoerd</div>
    }

    @if (minutesToday < 0) {
        <div class="user">Je hebt meer pauze ingevoerd dan je hebt gewerkt vandaag</div>
    }

    @if (minutesToday > 960) {
        <div class="user">Je hebt meer dan 16 uur ingevoerd</div>
    }

    @if (firstPendingDate) {
        <div class="user">Je uren van {{ firstPendingDate | date: 'EEE. dd MMM' }} zijn niet ingediend</div>
    }
    @if (!realisations?.length && !afasAanAfwezigheid?.length) {
        <div class="planning">
            <div class="container">
                <div class="content">
                    <div class="time">Niet ingepland</div>
                    <div class="status mt-1">
                        Wel aan het werk?<br />
                        Voeg zelf registraties toe of neem contact op met de planning.<br /><br />
                        Ingelogd als: {{ LocalStorage.user?.email }} / {{ LocalStorage.user?.id }}
                    </div>
                </div>
            </div>
        </div>
    }

    @for (aanAfw of afasAanAfwezigheid; track aanAfw; let last = $last; let index = $index) {
        <div class="planning">
            <div class="container">
                <div class="content">
                    <div class="time">
                        {{ aanAfw.hours | minutes }} - {{ aanAfw.omschrijving }}
                        {{ aanAfw.reasonDescr ? '-' + aanAfw.reasonDescr : '' }}
                    </div>
                    <div class="status mt-1">
                        {{ aanAfw.startDate | date: 'EEEE d MMMM yyyy' }} -
                        {{ aanAfw.leaveId ? '#' + aanAfw.leaveId : '' }} ({{
                            aanAfw.leaveCode ?? aanAfw.typeverzuimcode
                        }})
                    </div>
                    <div class="status mt-3">
                        <i>Deze uren worden nog niet meegeteld in je totaaluren</i>
                    </div>
                </div>
            </div>
        </div>
    }

    @for (realisation of realisations; track realisation.id; let last = $last; let index = $index) {
        <div
            class="planning"
            [class.travel]="realisation.hourtype !== RealisationHourtype.worktime"
            [class.removed]="realisation.removed"
            [class.disabled]="!(realisation | OwnHourEditAllowed)">
            <div class="container">
                <div class="content">
                    @if (!realisation.travel) {
                        <div class="status" [class.submitted]="realisation.submitted">
                            <span>{{
                                realisation.approved ? 'Goedgekeurd' : realisation.submitted ? 'ingediend' : 'concept'
                            }}</span>

                            <span class="type">{{ realisation.hourtype | hourtype }}</span>

                            <div class="d-flex justify-content-end">
                                @if (!realisation.approved && (realisation | OwnHourEditAllowed)) {
                                    <button
                                        class="planning-button mt-2"
                                        (click)="editComment(formMap.get(realisation).controls.comment_user)"
                                        mat-icon-button
                                        color="primary">
                                        <mat-icon fontSet="fas" fontIcon="fa-comment"></mat-icon>
                                    </button>
                                }

                                @if (
                                    realisation.approved &&
                                    !realisation.comment_user_approved_handled &&
                                    approvedCommentAllowed
                                ) {
                                    <button
                                        class="planning-button override-disabled mt-2"
                                        (click)="
                                            editComment(
                                                formMap.get(realisation).controls.comment_user_approved,
                                                'Opmerking goedgekeurde uren'
                                            )
                                        "
                                        mat-icon-button
                                        color="primary">
                                        <mat-icon fontSet="fas" fontIcon="fa-comment"></mat-icon>
                                    </button>
                                }
                            </div>
                        </div>
                    }

                    <div class="text_prepend">{{ realisation.text_prepend }}</div>

                    <div
                        class="time"
                        [class.invalid]="
                            !realisations[index - 1]?.removed &&
                            (realisation.begindate | datetimeBefore: realisations[index - 1]?.enddate) &&
                            realisations[index - 1].hourtype !== RealisationHourtype.sleep
                        "
                        (click)="editTime(realisation, 'begindate', -1)">
                        {{ formMap.get(realisation).value.begindate | date: 'HH:mm' }}<br />

                        @if (
                            realisation.hourtype === RealisationHourtype.driving_to &&
                            !(
                                formMap.get(realisation).value.begindate
                                | datetimeEquals: realisation.planning_has?.begindate
                            )
                        ) {
                            <div class="original">
                                {{ realisation.planning_has?.begindate | date: 'HH:mm' }}
                            </div>
                        }

                        @if (
                            realisation.hourtype === RealisationHourtype.worktime &&
                            !(
                                formMap.get(realisation).value.begindate
                                | datetimeEquals: realisation.planning_has?.work_begindate
                            )
                        ) {
                            <div class="original">
                                {{ realisation.planning_has?.work_begindate | date: 'HH:mm' }}
                            </div>
                        }

                        @if (
                            realisation.hourtype === RealisationHourtype.driving_back &&
                            !(
                                formMap.get(realisation).value.begindate
                                | datetimeEquals: realisation.planning_has?.work_enddate
                            )
                        ) {
                            <div class="original">
                                {{ realisation.planning_has?.work_enddate | date: 'HH:mm' }}
                            </div>
                        }

                        @if ((formMap.get(realisation).value.begindate | date: 'YMd') !== (date | date: 'YMd')) {
                            <div class="other-day">
                                {{ formMap.get(realisation).value.begindate | date: 'EEEE' }}
                            </div>
                        }
                    </div>

                    @if (
                        realisation.hourtype !== RealisationHourtype.travel_to &&
                        realisation.hourtype !== RealisationHourtype.travel_back
                    ) {
                        <div class="between">
                            @if (realisation.hourtype === RealisationHourtype.worktime) {
                                <div class="top">
                                    {{ realisation.planning?.contractor }}
                                    {{
                                        (
                                            realisation.project ??
                                            realisation.user_planning?.project ??
                                            realisation.planning?.project ??
                                            realisation.planning_has?.project
                                        )?.name
                                    }}
                                </div>
                            }
                            <div
                                class="bottom curpoint"
                                (click)="editProject(realisation)"
                                matTooltip="Klik om project aan te passen">
                                @if (
                                    realisation.hourtype === RealisationHourtype.driving_to ||
                                    realisation.hourtype === RealisationHourtype.driving_back
                                ) {
                                    <i class="fa-solid fa-truck"></i>&nbsp;
                                    {{
                                        (formMap.get(realisation).value.enddate.getTime() -
                                            formMap.get(realisation).value.begindate.getTime()) /
                                            1000 /
                                            60
                                    }}
                                    min &nbsp;-&nbsp;
                                }
                                {{ (realisation | realisationAfasProjectIdPipe) ?? realisation.leave?.comment }}
                            </div>
                        </div>
                    }

                    @if (
                        realisation.hourtype === RealisationHourtype.travel_to ||
                        realisation.hourtype === RealisationHourtype.travel_back
                    ) {
                        <div class="between traveltime">
                            <div class="bottom">
                                <div class="chip transparent">
                                    <i class="fas fa-car"></i
                                    >{{
                                        (formMap.get(realisation).value.enddate.getTime() -
                                            formMap.get(realisation).value.begindate.getTime()) /
                                            1000 /
                                            60
                                    }}
                                    min
                                </div>
                            </div>
                        </div>
                    }
                    <div class="time end" (click)="editTime(realisation, 'enddate', 1)">
                        {{ formMap.get(realisation).value.enddate | date: 'HH:mm' }}<br />
                        @if (
                            realisation.hourtype === RealisationHourtype.driving_to &&
                            !(
                                formMap.get(realisation).value.enddate
                                | datetimeEquals: realisation.planning_has?.work_begindate
                            )
                        ) {
                            <div class="original">
                                {{ realisation.planning_has?.work_begindate | date: 'HH:mm' }}
                            </div>
                        }

                        @if (
                            realisation.hourtype === RealisationHourtype.worktime &&
                            !(
                                formMap.get(realisation).value.enddate
                                | datetimeEquals: realisation.planning_has?.work_enddate
                            )
                        ) {
                            <div class="original">
                                {{ realisation.planning_has?.work_enddate | date: 'HH:mm' }}
                            </div>
                        }

                        @if (
                            realisation.hourtype === RealisationHourtype.driving_back &&
                            !(
                                formMap.get(realisation).value.enddate
                                | datetimeEquals: realisation.planning_has?.enddate
                            )
                        ) {
                            <div class="original">
                                {{ realisation.planning_has?.enddate | date: 'HH:mm' }}
                            </div>
                        }

                        @if ((formMap.get(realisation).value.enddate | date: 'YMd') !== (date | date: 'YMd')) {
                            <div class="other-day">
                                {{ formMap.get(realisation).value.enddate | date: 'EEEE' }}
                            </div>
                        }
                    </div>

                    <div class="text_append">{{ realisation.text_append }}</div>

                    <div class="comment">
                        @if (realisation.approved) {
                            <div class="text-center">
                                Je kunt je uren niet meer aanpassen omdat ze al zijn goedgekeurd.
                            </div>
                        } @else if (!realisation.approved && !(realisation | OwnHourEditAllowed)) {
                            <div class="text-center">
                                Je kunt je uren niet meer aanpassen omdat ze meer dan 48 uur in het verleden zijn.
                            </div>
                        }

                        <div class="row">
                            <div class="col-auto pr-0 d-flex align-items-center">
                                @if (!realisation.removed) {
                                    <button
                                        class="planning-button"
                                        (click)="delete(realisation)"
                                        mat-icon-button
                                        color="primary">
                                        <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                                    </button>
                                } @else if (realisation.removed && !realisation.approved) {
                                    <button
                                        class="planning-button"
                                        (click)="restore(realisation)"
                                        mat-icon-button
                                        color="primary">
                                        <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                                    </button>
                                }
                            </div>

                            <div class="col">
                                @if (realisation.planning_has?.comment && realisation.hourtype === 'worktime') {
                                    <div class="comment">
                                        <b>Toelichting planner</b><br />
                                        <span>{{ realisation.planning_has.comment }}</span>
                                    </div>
                                }

                                @if (
                                    realisation.planning_has?.transport_origin && realisation.hourtype === 'worktime'
                                ) {
                                    <div class="comment">
                                        <b>Locaties planner</b><br />
                                        @if (
                                            realisation.planning_has.transport_origin?.length > 0 &&
                                            realisation.planning_has.transport_origin !== 'none'
                                        ) {
                                            <span
                                                >Start:
                                                {{
                                                    realisation.planning_has.transport_origin
                                                        | replaceIf: 'next' : 'Zie vorige regel'
                                                }}<br
                                            /></span>
                                        }

                                        @if (realisation.planning_has.transport_worksite?.length > 0) {
                                            <span>Werk: {{ realisation.planning_has.transport_worksite }}<br /></span>
                                        }

                                        @if (
                                            realisation.planning_has.transport_destination?.length > 0 &&
                                            realisation.planning_has.transport_destination !== 'none'
                                        ) {
                                            <span
                                                >Einde:
                                                {{
                                                    realisation.planning_has.transport_destination
                                                        | replaceIf: 'next' : 'Zie volgende regel'
                                                }}<br
                                            /></span>
                                        }
                                    </div>
                                }

                                @if (realisation.comment_user) {
                                    <div
                                        class="comment"
                                        (click)="editComment(formMap.get(realisation).controls.comment_user)">
                                        <b>Toelichting</b><br />
                                        <span [innerHTML]="realisation.comment_user | nl2br"></span>
                                    </div>
                                }

                                @if (realisation.comment_user_approved) {
                                    <div
                                        class="comment"
                                        (click)="editComment(formMap.get(realisation).controls.comment_user_approved)">
                                        <b>Opmerking na goedkeuring</b><br />
                                        <span [innerHTML]="realisation.comment_user_approved | nl2br"></span>

                                        @if (realisation.comment_user_approved_handled) {
                                            <br />Verwerkt:
                                            {{ realisation.comment_user_approved_handled | date: 'd MMMM yyyy HH:mm' }}
                                        }
                                    </div>
                                }

                                @if (realisation.comment_manager) {
                                    <div class="comment">
                                        <b>Toelichting {{ environment.executorName }}</b
                                        ><br />
                                        <span [innerHTML]="realisation.comment_manager | nl2br"></span>
                                    </div>
                                }

                                @if (
                                    entityRealisationsMap.get(realisation)?.length > 0 &&
                                    realisation.hourtype !== 'travel_to' &&
                                    realisation.hourtype !== 'travel_back'
                                ) {
                                    <div class="comment">
                                        @for (rea of entityRealisationsMap.get(realisation); track rea) {
                                            @if (rea.entity?.use_once) {
                                                <i class="fa fa-check"></i>
                                                {{ rea.entity?.name | licensePlate }}
                                            }
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>

<div class="section bg-white">
    <div class="container mb-5 pb-5">
        <div class="d-flex justify-content-center" style="gap: 1rem">
            <a [routerLink]="['/tickets/0']" mat-raised-button color="accent">
                <i class="fa-regular fa-tickets"></i> Melden
            </a>
            @if (environment.officePhoneNumber) {
                <a [href]="'tel:' + environment.officePhoneNumber" mat-raised-button color="accent">
                    <i class="fa-regular fa-phone"></i> Kantoor
                </a>
            }
        </div>

        <div class="insight">
            @if (realisations?.length) {
                <div class="hours">
                    <div class="caption">Uren <strong>vandaag</strong></div>

                    <div class="time">{{ minutesToday | minutes }} uur</div>

                    @if (!realisations[0]?.user?.overtime) {
                        <div
                            class="chip curpoint"
                            [class.disabled]="!(realisations[0] | OwnHourEditAllowed) || approved"
                            (click)="changePause()"
                            matRipple>
                            <i class="fas fa-mug-saucer"></i>{{ formPause.value.pause | minutes }}
                        </div>
                    }
                </div>
            }
            <div class="divider"></div>

            <div class="hours">
                <div class="caption">
                    Totaaluren <strong>week {{ +(date | date: 'w') - ((date | date: 'c') == '0' ? 1 : 0) }}</strong>
                </div>

                <div class="time">{{ minutesThisWeek | minutes }} uur</div>
            </div>
        </div>
    </div>
</div>

<div class="button-wrapper">
    <div class="container">
        <div class="buttons">
            <button class="planning-button" routerLink="{{ backTo }}" mat-raised-button color="accent">Terug</button>

            @if (Functionalities.CommonHourCheck | hasFunctionality) {
                <button
                    class="planning-button d-none d-lg-block"
                    mat-raised-button
                    color="accent"
                    routerLink="/dagcontrole/{{ date | date: 'yyyy-MM-dd' }}">
                    Dagcontrole
                </button>
            }

            <div class="settings-menu">
                <app-settings-menu [date]="date"></app-settings-menu>
            </div>

            @let hourCheckFunctionalities = [Functionalities.CommonHourCheck, Functionalities.HourCheck];
            @if (hourCheckFunctionalities | hasFunctionality) {
                <button
                    class="planning-button d-none d-sm-block"
                    mat-raised-button
                    color="accent"
                    routerLink="/check-hours/{{ date | date: 'yyyy-MM-dd' }}">
                    Urencontrole
                </button>
            }

            <button class="planning-button" [disabled]="!addAllowed" (click)="add()" mat-raised-button color="primary">
                Toevoegen
            </button>

            @if (!approved && realisations?.length) {
                <button
                    class="planning-button"
                    [disabled]="minutesToday < 0 || overlapping || saving || form?.dirty || formPause?.dirty"
                    [class.pending-submit]="!submitted"
                    (click)="submitHours()"
                    mat-raised-button
                    color="primary">
                    <span class="d-none d-sm-inline">Urenregistratie</span>
                    {{ saving ? 'indienen...' : submitted ? 'ingediend' : 'indienen' }}
                </button>
            }
        </div>
    </div>
</div>
